import { createIdempotencyKey } from "@trigger.dev/core/v3";
export const idempotencyKeys = {
    create: createIdempotencyKey,
};
//# sourceMappingURL=idempotencyKeys.js.map